import { Table } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { FecThirdPartySortKey } from '../../../../../../enums/fecThirdPartySortKey'
import type { FecThirdPartySortDirection } from '../../../../../../utils/sortFecThirdPartyMappings'

interface ThirdPartyTableHeaderProps {
  accountNoSortDirection: FecThirdPartySortDirection
  onSort: (key: FecThirdPartySortKey) => void
  typeSortDirection: FecThirdPartySortDirection
}

export const ThirdPartyTableHeader = ({
  accountNoSortDirection,
  onSort,
  typeSortDirection,
}: ThirdPartyTableHeaderProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell
          onSort={() => onSort(FecThirdPartySortKey.Type)}
          sortable
          sortDirection={typeSortDirection}
          width={180}
        >
          {t('settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.columns.type')}
        </Table.HeaderCell>
        <Table.HeaderCell
          onSort={() => onSort(FecThirdPartySortKey.AccountNo)}
          sortable
          sortDirection={accountNoSortDirection}
          width={136}
        >
          {t('settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.columns.account_no')}
        </Table.HeaderCell>
        <Table.HeaderCell>
          {t('settings.organization.accounting.fec_file_import.modal.mapping_step.third_party.columns.label')}
        </Table.HeaderCell>
      </Table.Row>
    </Table.Header>
  )
}
